import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ToggleIconButtonBase } from '@/components/ui/Button/ToggleButton';
import { BookmarkIcon, BookmarkOutlineIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
/**
 * 共通：ブックマーク切り替えボタンコンポーネント
 * @param props
 * @constructor
 */
export const ToggleBookmarkIconButton = (props) => {
    const { boolState, className = '', disabled, falseIconClassName, falseIconColor, onClick, size, trueIconClassName, trueIconColor, type, value, } = props;
    return (_jsx(ToggleIconButtonBase, { boolState: boolState, className: className, disabled: disabled, falseIconClassName: falseIconClassName, falseIconColor: falseIconColor, falseIconComponent: BookmarkOutlineIcon, onClick: onClick, size: size, trueIconClassName: trueIconClassName, trueIconColor: trueIconColor, trueIconComponent: BookmarkIcon, type: type, value: value }));
};
